import { Box, Theme, makeStyles, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  iconButton: {
    padding: 0,
  },
}));

export const CardHeader = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {children}
      {onClick && (
        <IconButton className={classes.iconButton} onClick={onClick}>
          <Close />
        </IconButton>
      )}
    </Box>
  );
};
